import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';

const LineChartD = ({ data }) => {

const groupDataByDate = (data, filter) => {
    const groupedData = {};
  
    const currentDate = new Date();
  
    data.forEach(item => {
      const date = new Date(item.created_at);
      let key;
  
      if (filter === "last_7_days") {
        const diffInDays = Math.floor((currentDate - date) / (1000 * 3600 * 24));
        if (diffInDays < 7) {
          key = date.toISOString().split('T')[0];
          groupedData[key] = (groupedData[key] || 0) + item.qty;
        }
      }
  
      else if (filter === "last_month") {
        const diffInDays = Math.floor((currentDate - date) / (1000 * 3600 * 24));
        if (diffInDays < 30) {
          key = date.toISOString().split('T')[0];
          groupedData[key] = (groupedData[key] || 0) + item.qty;
        }
      }
  
      else if (filter === "last_year") {
        if (date.getFullYear() === currentDate.getFullYear()) {
          key = `${date.getFullYear()}-${date.getMonth() + 1}`;
          groupedData[key] = (groupedData[key] || 0) + item.qty;
        }
      }
  
      else if (filter === "all_time") {
        key = `${date.getFullYear()}-${date.getMonth() + 1}`;
        groupedData[key] = (groupedData[key] || 0) + item.qty;
      }
    });
  
    const result = Object.keys(groupedData).map(key => ({
      date: key,
      total: groupedData[key]
    }));
  
    result.sort((a, b) => new Date(a.date) - new Date(b.date));
  
    return result;
  };
  
  
    const [filter, setFilter] = useState("last_7_days");
  
    const groupedData = groupDataByDate(data, filter);
  
    return (
      <div>
        <div>
          <label className="form-label" htmlFor="filter">Seleccionar filtro: </label>
          <select className="form-select mb-3" id="filter" onChange={e => setFilter(e.target.value)} value={filter}>
            <option value="last_7_days">Últimos 7 días</option>
            <option value="last_month">Último mes</option>
            <option value="last_year">Último año</option>
            <option value="all_time">Todo el tiempo</option>
          </select>
        </div>
  
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={groupedData} margin={{ top: 20, right: 20, left: 20, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" height={60} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="total"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
            >
              <LabelList position="top" offset={10} />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  };
  
  export default LineChartD;